"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNormalizeCaptions = getNormalizeCaptions;
exports.getNormalizeClips = getNormalizeClips;

var _captionUtils = require("./caption-utils");

var _clipUtils = require("./clip-utils");

function getNormalizeCaptions(captions, _config) {
  return captions.map(caption => {
    const normalizeCaption = (0, _captionUtils.normalizeCaptionObject)(caption);
    const {
      name
    } = normalizeCaption.data;
    let config = {}; // add config data into caption object if needed

    if (_config) {
      config = { ..._config[name]
      };

      if (config.inputs && caption.type === 'template2') {
        const conf = {};
        config.inputs.map(input => {
          conf[input.name] = input;
          return conf;
        });
        config.inputs = conf;
      }
    }

    return { ...normalizeCaption,
      config
    };
  });
}

function getNormalizeClips(clips) {
  return clips.map((clip, index, arr) => {
    const retVal = (0, _clipUtils.normalizeClipObject)(clip);
    retVal.uiTime = (0, _clipUtils.getClipUiTimes)(clip, arr[index + 1], index);
    return retVal;
  });
}